var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link position-relative h-100 d-flex align-items-center",
      class: _vm.linkClass,
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _c("span", { class: _vm.spanClass }, [_vm._v(_vm._s(_vm.wishListCount))]),
      _vm._v(" "),
      _vm.logo.length > 0
        ? _c("span", {
            staticClass: "logo-navbar",
            style: { "background-image": "url('" + _vm.logo + "')" },
          })
        : _c("i", {
            staticClass: "fa",
            class: [
              _vm.wishListCount ? "fa-heart" : "fa-heart-o",
              _vm.iconClass,
            ],
            attrs: { "aria-hidden": "true" },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }